import styled, { Palette, PaletteVariants } from 'styled-components';
import { TinkFontSizes } from '../../providers/ThemeProvider/theme';

export interface IconBaseProps {
  color?: Palette;
  shade?: PaletteVariants;
  fontSize?: TinkFontSizes;
  spacing?: 'left' | 'right';
  monochrome?: boolean;
  height?: string;
  width?: string;
}

export const IconBase = styled.svg.attrs({ role: 'presentation' })<IconBaseProps>`
  fill: ${(props) =>
    props.color ? props.theme.palette[props.color][props.shade || 'main'] : 'currentColor'};
  ${({ theme, fontSize }) =>
    fontSize
      ? `
      /**
       * Set !important to increase specificity and
       * to avoid accidental overrides when used with
       * 3rd party code like material-ui.
       */
    font-size: ${theme.sizes[fontSize]} !important;
  `
      : `
    font-size: ${theme.sizes.normedium};
  `}
  height: ${(props) => (props.height ? props.height : '1em')};
  width: ${(props) => (props.width ? props.width : '1em')};
  margin-left: ${(props) => (props.spacing === 'left' ? props.theme.sizes.xsmall : '')};
  margin-right: ${(props) => (props.spacing === 'right' ? props.theme.sizes.xsmall : '')};
`;
